<template>
    <main v-if="user" class="flex justify-center bg-gray-50">
        <HeaderComponent/>
        <section class="w-full pb-[100px] lg:pl-[50px] lg:pt-[95px] pt-[95px] max-h-screen overflow-y-auto relative flex justify-start flex-col lg:p-[25px] p-[20px] h-auto min-h-screen">
            <!-- Notifications -->
            <div class="fixed top-[80px] lg:left-[calc(50%+140px)] left-[50%] z-[100] translate-x-[-50%] w-[90%] max-w-[400px] flex flex-col">
                <div v-if="errorMessage" class="w-full rounded-lg text-white bg-red-500 my-2 font-medium text-center p-4 shadow-lg transition-all duration-300">
                    {{ errorMessage }}
                </div>
                <div v-if="successMessage" class="w-full rounded-lg text-white bg-emerald-500 my-2 font-medium text-center p-4 shadow-lg transition-all duration-300">
                    {{ successMessage }}
                </div>
            </div>

            <!-- Main content -->
            <div class="w-full flex flex-col lg:flex-row gap-6">
                <!-- Left section (Products/Info) -->
                <div class="lg:w-8/12 w-full flex flex-col gap-6">
                    <!-- Products section -->
                    <div v-if="achat" class="bg-white rounded-xl relative shadow-sm border border-gray-200">
                        <div class="p-4 border-b border-gray-200">
                            <h2 class="text-lg font-semibold text-gray-800">Produits sélectionnés</h2>
                        </div>
                        
                        <div class="w-full relative">
                            <table class="min-w-full divide-y relative divide-gray-200">
                                <thead class="bg-gray-50 relative">
                                    <tr>
                                        <th scope="col" class="md:px-6 px-[10px] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Produit</th>
                                        <th scope="col" class="md:px-6 px-[10px] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Prix</th>
                                        <th scope="col" class="md:px-6 px-[10px] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantité</th>
                                        <th scope="col" class="md:px-6 px-[10px] py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden lg:table-cell">Total</th>
                                    </tr>
                                </thead>
                                <tbody class="bg-white relative divide-y divide-gray-200">
                                    <tr v-for="(produit, index) in produits" :key="index">
                                        <td class="md:px-6 px-[10px] py-4">
                                            <div class="flex items-center">
                                                <div class="flex-shrink-0 h-10 w-10">
                                                    <img
                                                        class="md:h-10 md:w-10 w-[30px] h-[30px] rounded-full object-cover"
                                                        :src="produit?.lotPhoto || defaultImage"
                                                        @error="onImageError($event)"
                                                        alt="Photo produit"
                                                    />
                                                </div>
                                                <div class="md:ml-4 ml-[8px]">
                                                    <div class="text-sm font-medium text-gray-900">{{ produit.lotName }}</div>
                                                    <div v-if="produit.capacities && produit.colors" class="text-xs text-gray-500">
                                                        <span v-if="produit.capacities[0]">{{ produit.capacities[0] }}</span>
                                                        <span v-if="produit.colors[0]"> - {{ produit.colors[0] }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="md:px-6 px-[10px] py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ produit.prix_reduit }}
                                        </td>
                                        <td class="md:px-6 px-[10px] py-4 whitespace-nowrap text-sm text-gray-900">
                                            <div class="flex items-center space-x-2">
                                                <button @click="diminuerQuantite(index)" class="w-6 h-6 flex items-center justify-center border border-gray-300 rounded hover:bg-gray-100">
                                                    <i class="fa-solid fa-minus text-xs"></i>
                                                </button>
                                                <span>{{ produit.quantity }}</span>
                                                <button @click="augmenterQuantite(index)" class="w-6 h-6 flex items-center justify-center border border-gray-300 rounded hover:bg-gray-100">
                                                    <i class="fa-solid fa-plus text-xs"></i>
                                                </button>
                                            </div>
                                        </td>
                                        <td class="md:px-6 px-[10px] py-4 whitespace-nowrap text-sm text-gray-500 hidden lg:table-cell">
                                            {{ produit.stotal }}
                                        </td>
                                    </tr>
                                    <tr v-if="produits.length === 0">
                                        <td colspan="4" class="md:px-6 px-[10px] py-4 text-center text-sm text-gray-500">
                                            Aucun produit sélectionné
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Product search and add with filters -->
                        <div class="p-4 border-t border-gray-200 relative">
                            <div class="flex flex-col gap-4">
                                <!-- Search and add button -->
                                <div class="flex">
                                    <input v-model="recherche" @input="fetchProduitsFiltres" type="text" placeholder="Recherchez un produit" class="flex-grow p-2 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500">
                                    <button @click="afficherListeProduits" class="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-r-lg font-medium">
                                        <span class="hidden md:inline">Ajouter un produit</span>
                                        <span class="md:hidden">Ajouter</span>
                                    </button>
                                </div>
                                
                            </div>
                            
                            <!-- Products dropdown -->
                            <div v-if="afficherProduits" class="absolute left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto">
                                <ul>
                                    <li v-for="produit in produitsFiltres" :key="produit._id" @click="ajouterProduit(produit)" class="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 h-10 w-10">
                                                <img
                                                    class="h-10 w-10 rounded-full object-cover"
                                                    :src="produit?.lotPhoto || defaultImage"
                                                    @error="onImageError($event)"
                                                    alt="Photo produit"
                                                />
                                            </div>
                                            <div class="ml-4">
                                                <div class="text-sm font-medium text-gray-900">{{ produit.lotName }}</div>
                                                <div v-if="produit.capacities && produit.colors" class="text-xs text-gray-500">
                                                    <span v-if="produit.capacities[0]">{{ produit.capacities[0] }}</span>
                                                    <span v-if="produit.colors[0]"> - {{ produit.colors[0] }}</span>
                                                    <span v-if="produit.imei1"> - Imei1({{ produit.imei1 }})</span>
                                                </div>
                                                <div class="text-xs font-bold text-gray-700">{{ produit.prix_reduit }} FCFA - {{ produit.stock }}</div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Information section -->
                    <div v-if="information" class="bg-white rounded-xl shadow-sm border border-gray-200">
                        <div class="p-6 space-y-6">
                            <!-- Seller info -->
                            <div>
                                <h3 class="text-lg font-medium text-gray-500 mb-4">Information sur le vendeur</h3>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Nom du(de la) vendeur(se)</label>
                                        <input type="text" readonly v-model="fullname" class="w-full px-3 py-2 bg-gray-100 rounded-md text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Poste</label>
                                        <input type="text" readonly v-model="user.poste" class="w-full px-3 py-2 bg-gray-100 rounded-md text-sm">
                                    </div>
                                    <div class="md:col-span-2">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Boutique</label>
                                        <input type="text" readonly v-model="user.boutique" class="w-full px-3 py-2 bg-gray-100 rounded-md text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Numéro</label>
                                        <input type="text" readonly v-model="user.phone" class="w-full px-3 py-2 bg-gray-100 rounded-md text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                        <input type="text" readonly v-model="user.email" class="w-full px-3 py-2 bg-gray-100 rounded-md text-sm">
                                    </div>
                                </div>
                            </div>

                            <!-- Client info -->
                            <div class="pt-6 border-t border-gray-200">
                                <h3 class="text-lg font-medium text-gray-500 mb-4">Informations du Client</h3>
                                <!-- Recherche client existant -->
                                <div class="relative mb-4">
                                    <div class="relative">
                                        <i class="fa-solid fa-search text-gray-400 absolute left-3 top-3 text-sm"></i>
                                        <input v-model="clientSearch" @input="searchClients" type="text" placeholder="Rechercher un client (numéro, email ou nom)" class="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <ul v-if="clientResults.length" class="absolute left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-52 overflow-y-auto">
                                        <li v-for="(c, i) in clientResults" :key="i" @click="selectClient(c)" class="p-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0">
                                            <span class="text-sm font-medium text-gray-800">{{ c.client?.nom }} {{ c.client?.prenoms }}</span>
                                            <span class="text-xs text-gray-500 block">{{ c.client?.numero }} <span v-if="c.client?.email"> • {{ c.client?.email }}</span></span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Nom</label>
                                        <input type="text" v-model="client.nom" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Prénoms</label>
                                        <input type="text" v-model="client.prenoms" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div class="md:col-span-2">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Adresse</label>
                                        <input type="text" v-model="client.adresse" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Numéro</label>
                                        <input type="text" v-model="client.numero" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                        <input type="text" v-model="client.email" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                </div>
                            </div>

                            <!-- Payment method -->
                            <div class="pt-6 border-t border-gray-200">
                                <h3 class="text-lg font-medium text-gray-500 mb-4">Moyen de paiement</h3>
                                <div class="space-y-3">
                                    <div class="flex items-center">
                                        <input type="radio" name="paiement" value="Espece" id="espece" v-model="selectedPaymentMethod" class="h-4 w-4 text-orange-600 focus:ring-orange-500">
                                        <label for="espece" class="ml-3 block text-sm font-medium text-gray-700">En espèce</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="radio" name="paiement" value="Mobile" id="mobile" v-model="selectedPaymentMethod" class="h-4 w-4 text-orange-600 focus:ring-orange-500">
                                        <label for="mobile" class="ml-3 block text-sm font-medium text-gray-700">Paiement mobile</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="radio" name="paiement" value="carte" id="carte" v-model="selectedPaymentMethod" class="h-4 w-4 text-orange-600 focus:ring-orange-500">
                                        <label for="carte" class="ml-3 block text-sm font-medium text-gray-700">Paiement par carte</label>
                                    </div>
                                    
                                    <div v-if="selectedPaymentMethod === 'Mobile' || selectedPaymentMethod === 'carte'" class="mt-2">
                                        <label for="numero" class="block text-sm font-medium text-gray-700 mb-1">Entrez le numéro</label>
                                        <input type="text" id="numero" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                </div>
                            </div>

                            <!-- Sale type -->
                            <div class="pt-6 border-t border-gray-200">
                                <div class="flex space-x-4">
                                    <button @click="selecteType('Vente')" :class="{'bg-blue-600 text-white': type === 'Vente', 'bg-white text-blue-600 border border-blue-600': type !== 'Vente'}" class="px-4 py-2 rounded-md text-sm font-medium transition-colors">
                                        Vente
                                    </button>
                                    <button @click="selecteType('Troc')" :class="{'bg-green-600 text-white': type === 'Troc', 'bg-white text-green-600 border border-green-600': type !== 'Troc'}" class="px-4 py-2 rounded-md text-sm font-medium transition-colors">
                                        Troc
                                    </button>
                                </div>

                                <!-- Trade form -->
                                <div v-if="type === 'Troc'" class="mt-6 space-y-4">
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Nom Lot <span class="text-red-500">*</span></label>
                                        <input type="text" v-model="nomProduit" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Description <span class="text-red-500">*</span></label>
                                        <input type="text" v-model="descriptionProduit" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">IMEI 1 <span class="text-red-500">*</span></label>
                                        <input type="text" v-model="imei1" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">IMEI 2 <span class="text-red-500">*</span></label>
                                        <input type="text" v-model="imei2" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Stock <span class="text-red-500">*</span></label>
                                        <select v-model="stock" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                                            <template v-if="user.isSuper">
                                              <option value="Stock Parakou">Stock Parakou</option>
                                              <option value="Stock Calavi">Stock Calavi</option>
                                              <option value="Magasin Parakou">Magasin Parakou</option>
                                              <option value="Magasin Calavi">Magasin Calavi</option>
                                            </template>
                                            <template v-else>
                                              <option :value="`Stock ${user.boutique}`">Stock {{ user.boutique }}</option>
                                            </template>
                                        </select>
                                    </div>
                                    <div class="relative">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Estimation du Prix <span class="text-red-500">*</span></label>
                                        <input type="text" v-model.number="prix" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm pr-10">
                                        <span class="absolute right-3 top-8 text-sm font-medium text-gray-500">FCFA</span>
                                    </div>
                                    <div class="relative">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">Prix de revente<span class="text-red-500">*</span></label>
                                        <input type="text" v-model.number="prix_reel" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm pr-10">
                                        <span class="absolute right-3 top-8 text-sm font-medium text-gray-500">FCFA</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right section (Summary) -->
                <div class="lg:w-4/12 w-full">
                    <div class="bg-white rounded-xl shadow-sm border border-gray-200 sticky top-6">
                        <div class="p-4 border-b border-gray-200">
                            <h2 class="text-lg font-semibold text-gray-800">Résumé de la commande</h2>
                        </div>
                        
                        <div v-if="produits.length !== 0 && information == true" class="p-4 border-b border-gray-200 max-h-64 overflow-y-auto">
                            <div v-for="(produit, index) in produits" :key="index" class="flex justify-between items-center py-2">
                                <div class="flex items-center">
                                    <div class="w-8 h-8 rounded-full overflow-hidden shadow-sm mr-3">
                                        <img :src="produit?.lotPhoto || defaultImage" @error="onImageError($event)" alt="Photo produit" class="w-full h-full object-cover">
                                    </div>
                                    <div>
                                        <p class="text-sm font-medium text-gray-700">{{ produit.lotName }}</p>
                                        <p class="text-xs text-gray-500">x{{ produit.quantity }}</p>
                                    </div>
                                </div>
                                <span class="text-sm font-semibold text-gray-700">{{ produit.stotal }}</span>
                            </div>
                        </div>
                        
                        <div class="p-4 space-y-3">
                            <div v-for="(categorie, index) in categories" :key="index" class="flex justify-between">
                                <span class="text-sm text-gray-600">{{ categorie.nom }}</span>
                                <span class="text-sm font-medium text-gray-800">{{ categorie.total }} FCFA</span>
                            </div>
                        </div>
                        
                        <div class="p-4 border-t border-gray-200 space-y-3">
                            <div class="flex justify-between">
                                <span class="text-sm font-medium text-gray-700">Réduction</span>
                                <span class="text-sm font-medium text-gray-700">{{ reductionPourcentage }} %</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="text-sm font-medium text-gray-700">Total</span>
                                <span class="text-sm font-bold text-gray-900">{{ totalApresReduction }} FCFA</span>
                            </div>
                            
                            <div class="pt-2">
                                <label class="block text-sm font-medium text-gray-700 mb-1">Montant de la réduction</label>
                                <input v-model="reductionMontant" @input="calculerReduction" type="text" placeholder="0" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 text-sm">
                            </div>
                        </div>
                        
                        <div class="p-4 border-t border-gray-200 flex space-x-3">
                            <button @click="toggleMenu" :class="{'bg-gray-800': information && !achat, 'bg-gray-600': !information && achat}" class="flex-1 py-2 text-white rounded-md font-medium text-sm">
                                {{ information && !achat ? 'Retour' : 'Valider la commande' }}
                            </button>
                            <button 
                              @click="createVente()" 
                              :disabled="isLoading || (type === 'Troc' && !isTrocFormValid())"
                              v-if="information && !achat" 
                              class="flex-1 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-md font-medium text-sm flex justify-center items-center"
                            >
                              <span v-if="!isLoading">Confirmer</span>
                              <span v-else class="flex items-center gap-2">
                                <div class="spinner">
                                  <div></div>
                                  <div></div>
                                </div>
                                Enregistrement...
                              </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Success modal -->
            <div v-if="isDone" class="fixed lg:left-[280px] inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50">
                <div class="bg-white rounded-xl p-8 max-w-md w-full mx-4 text-center">
                    <h1 class="text-2xl font-bold text-gray-800 mb-2">Tout est fait !</h1>
                    <img src="../assets/images/all-done.png" alt="" class="h-32 mx-auto my-4">
                    <p class="text-gray-600 mb-6">
                        La commande a été enregistrée avec succès en votre nom et la facture a été envoyée au client! Vous trouverez dans l'onglet Historique le résumé de la vente.
                    </p>
                    <button @click="reload()" class="w-full bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-md font-medium">
                        Revenir à la page de vente
                    </button>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup>
import HeaderComponent from "../components/HeaderComponent.vue"
import { ref, computed, onMounted, watch } from 'vue'
import axios from 'axios'
import { useAuthStore } from '@/store/auth';

const authStore = useAuthStore();
const user = computed(() => authStore.user);

// Default values and functions
const defaultImage = '/img/default.png'
function onImageError(event) {
  event.target.src = defaultImage
}

// Filters state
const filters = ref({
  search: '',
  categorie: '',
  capacities: '',
  colors: '',
  stock: user.value.isSuper ? '' : `Stock ${user.value.boutique}`,
  sortBy: 'createdAt',
  sortOrder: 'desc'
});

const isTrocFormValid = () => {
  if (type.value !== 'Troc') return true;
  
  return nomProduit.value && 
         descriptionProduit.value && 
         imei1.value && 
         imei2.value && 
         stock.value && 
         prix.value && 
         prix_reel.value;
};

const availableFilters = ref({
  capacities: [],
  colors: [],
  stocks: [],
  categories: [],
  etats: []
});

// Fetch products with filters
const produitsFiltres = ref([]);
const isLoadingProducts = ref(false);

const fetchProduitsFiltres = async () => {
  try {
    isLoadingProducts.value = true;

    const params = {
      search: recherche.value,
      boutique: user.value.boutique,
      poste: user.value.poste,
      isSuper: user.value.isSuper
    };

    const response = await axios.get('/api/lots', { params });

    produitsFiltres.value = response.data.lots.flatMap(lot =>
      lot.produits.map(produit => ({
        ...produit,
        lotName: lot.name,
        lotCategorie: lot.categorie,
        lotPhoto: lot.photos?.[0] || defaultImage,
        _id: produit._id || Math.random().toString(36).substr(2, 9)
      }))
    );

    availableFilters.value = response.data.filters || {};
  } catch (error) {
    console.error('Error fetching filtered products:', error);
    errorMessage.value = 'Erreur lors du chargement des produits';
    hideErrorMessageAfterDelay();
  } finally {
    isLoadingProducts.value = false;
  }
};


// Watch for search changes
const recherche = ref("");
watch(recherche, (newVal) => {
  if (newVal.length > 2 || newVal.length === 0) {
    fetchProduitsFiltres();
  }
});

// Product selection and cart management
const produits = ref([]);
const afficherProduits = ref(false);

function ajouterProduit(produit) {
    const produitExistant = produits.value.find(p => p._id === produit._id);
    if (produitExistant) {
        produitExistant.quantity++;
        produitExistant.stotal = produitExistant.quantity * produitExistant.prix_reduit;
    } else {
        produits.value.push({
            ...produit,
            quantity: 1,
            stotal: produit.prix_reduit
        });
    }
    afficherProduits.value = false;
}

function augmenterQuantite(index) {
    const produit = produits.value[index];
    if (produit.quantity < produit.quantite) {
        produit.quantity++;
        produit.stotal = produit.quantity * produit.prix_reduit;
    } else {
        errorMessage.value = 'Quantité insuffisante en stock';
        hideErrorMessageAfterDelay();
    }
}

function diminuerQuantite(index) {
    if (produits.value[index].quantity > 1) {
        produits.value[index].quantity--;
        produits.value[index].stotal = produits.value[index].quantity * produits.value[index].prix_reduit;
    } else {
        produits.value.splice(index, 1);
    }
}

function afficherListeProduits() {
    fetchProduitsFiltres();
    afficherProduits.value = !afficherProduits.value;
}

// Client and sale information
const client = ref({
  nom: '',
  prenoms: '',
  adresse: '',
  email: '',
  numero: ''
});

const fullname = computed(() => `${user.value.firstname} ${user.value.lastname}`);

// Recherche d'un client existant (numéro, email ou nom)
const clientSearch = ref('');
const clientResults = ref([]);
let clientSearchTimer = null;
function searchClients() {
  clearTimeout(clientSearchTimer);
  const q = clientSearch.value.trim();
  if (q.length < 2) { clientResults.value = []; return; }
  clientSearchTimer = setTimeout(async () => {
    try {
      const { data } = await axios.get('/api/sales/unique-client', { params: { search: q, limit: 8 } });
      clientResults.value = data.data || [];
    } catch (e) { clientResults.value = []; }
  }, 300);
}
function selectClient(sale) {
  const c = sale.client || {};
  client.value = {
    nom: c.nom || '',
    prenoms: c.prenoms || '',
    adresse: c.adresse || '',
    email: c.email || '',
    numero: c.numero || ''
  };
  clientResults.value = [];
  clientSearch.value = '';
}

// Sale type and payment
const selectedPaymentMethod = ref('');
const type = ref('Vente');
const selecteType = (typeText) => {
  type.value = typeText;
};

// Troc form
const troc = ref({});
const nomProduit = ref('');
const descriptionProduit = ref('');
const imei1 = ref('');
const imei2 = ref('');
const stock = ref('');
const prix = ref(null);
const prix_reel = ref(null);


const totalApresReduction = computed(() => {
    const totalTroc = type.value === 'Troc' ? (Number(prix.value) || 0) : 0;
    
    return (total.value - reductionMontant.value) - totalTroc;
});

const submitForm = async () => {
    isLoading.value = true;
  try {
    const response = await axios.post(`/api/lots-produit`, {
      "name": nomProduit.value,
      "description": descriptionProduit.value,
      "categorie": "iOS",
      "seuil": 1,
      "produits": [
        {
          "imei1": imei1.value,
          "imei2": imei2.value,
          "stock": stock.value,
          "quantite": 1,
          "prix": prix_reel.value,
          "prix_achat": prix.value,
          "capacities": ["Description"],
          "colors": ["Description"],
          "prix_reduit": prix_reel.value
        }
      ]
    });

    const lot = response.data.lot;
    const produit = lot.produits[0]; 

    troc.value = {
      lotName: lot.name || '', 
      lotCategorie: lot.categorie || '', 
      imei1: produit.imei1 || '', 
      imei2: produit.imei2 || '', 
      stock: produit.stock || '',
      capacities: produit.capacities || [], 
      colors: produit.colors || [], 
      prix: produit.prix || 0, 
      prix_reduit: produit.prix_achat || 0,
      quantity: produit.quantite || 0,
      stotal: produit.prix_achat ? produit.prix_achat * produit.quantite : produit.prix_achat * produit.quantite
    };

    // Reset form
    nomProduit.value = '';
    descriptionProduit.value = '';
    imei1.value = '';
    imei2.value = '';
    stock.value = '';
    prix.value = null;
    prix_reel.value = null;

    successMessage.value = 'Produit ajouté avec succès pour le troc';
    hideSuccessMessageAfterDelay();
  } catch (error) {
    errorMessage.value = 'Erreur lors de l\'ajout du produit';
    hideErrorMessageAfterDelay();
  } finally {
    isLoading.value = false;
  }
};

// Sale creation
const isDone = ref(false);
const isLoading = ref(false);

const createVente = async () => {
  isLoading.value = true;
  try {
    let trocProduit = null;
    
    // Si c'est un troc, créer d'abord le produit
    if (type.value === 'Troc') {
      // Valider les champs du troc
      if (!nomProduit.value || !descriptionProduit.value || !imei1.value || !imei2.value || !stock.value || !prix.value || !prix_reel.value) {
        errorMessage.value = 'Veuillez remplir tous les champs du troc';
        hideErrorMessageAfterDelay();
        isLoading.value = false;
        return;
      }

      // Créer le produit troc
      const trocResponse = await axios.post(`/api/lots-produit`, {
        "name": nomProduit.value,
        "description": descriptionProduit.value,
        "categorie": "iOS",
        "seuil": 1,
        "produits": [
          {
            "imei1": imei1.value,
            "imei2": imei2.value,
            "stock": stock.value,
            "quantite": 1,
            "prix": prix_reel.value,
            "prix_achat": prix.value,
            "capacities": ["Description"],
            "colors": ["Description"],
            "prix_reduit": prix_reel.value
          }
        ]
      });

      const lot = trocResponse.data.lot;
      const produit = lot.produits[0]; 

      trocProduit = {
        lotName: lot.name || '', 
        lotCategorie: lot.categorie || '', 
        imei1: produit.imei1 || '', 
        imei2: produit.imei2 || '', 
        stock: produit.stock || '',
        capacities: produit.capacities || [], 
        colors: produit.colors || [], 
        prix: produit.prix || 0, 
        prix_reduit: produit.prix_achat || 0,
        quantity: produit.quantite || 0,
        stotal: produit.prix_achat ? produit.prix_achat * produit.quantite : produit.prix_achat * produit.quantite
      };

      successMessage.value = 'Produit troc créé avec succès';
      hideSuccessMessageAfterDelay();
    }

    // Créer la vente
    const response = await axios.post('/api/sales', {
      produits: produits.value,
      client: client.value,
      troc: trocProduit,
      vendeur: {
        _id: user.value._id,
        nom: user.value.lastname,
        prenoms: user.value.firstname,
        email: user.value.email,
        numero: user.value.phone,
        boutique: user.value.boutique,
        poste: user.value.poste
      },
      type: type.value,
      total: Number(totalApresReduction.value) + Number(reductionMontant.value),
      reductionMontant: reductionMontant.value,
      totalApresReduction: totalApresReduction.value,
      moyenDePaiement: selectedPaymentMethod.value,
    });

    isDone.value = true;
    produits.value = [];
    
    if (type.value === 'Troc') {
      nomProduit.value = '';
      descriptionProduit.value = '';
      imei1.value = '';
      imei2.value = '';
      stock.value = '';
      prix.value = null;
      prix_reel.value = null;
    }

  } catch (error) {
    console.error('Error creating sale:', error);
    errorMessage.value = 'Erreur lors de la validation de la vente';
    hideErrorMessageAfterDelay();
  } finally {
    isLoading.value = false;
  }
};

// UI state management
const information = ref(false);
const achat = ref(true);

function toggleMenu() {
    information.value = !information.value;
    achat.value = !achat.value;
}

function reload() {
    window.location.reload();
}

// Calculations
const reductionMontant = ref(0);

const total = computed(() => {
    return produits.value.reduce((acc, produit) => acc + produit.stotal, 0);
});


const categories = computed(() => {
    const categoriesExistantes = ['iOS', 'Android', 'Accessoires'];
    const result = categoriesExistantes.map(categorie => {
        const produitsCategorie = produits.value.filter(p => p.lotCategorie === categorie);
        const totalCategorie = produitsCategorie.reduce((acc, produit) => acc + produit.stotal, 0);
        return {
            nom: categorie,
            total: totalCategorie
        };
    });
    return result;
});

const reductionPourcentage = computed(() => {
    if (total.value === 0) return 0;
    return ((reductionMontant.value / total.value) * 100).toFixed(2);
});

function calculerReduction() {
    if (reductionMontant.value < 0) {
        reductionMontant.value = 0;
    }
}

// Notifications
const errorMessage = ref('');
const successMessage = ref('');

const hideSuccessMessageAfterDelay = () => {
    setTimeout(() => {
      successMessage.value = ''; 
    }, 5000);
};
  
const hideErrorMessageAfterDelay = () => {
    setTimeout(() => {
      errorMessage.value = ''; 
    }, 10000);
};

// Categories based on user role
const categoriesT = ref([]);

const setCategories = (poste) => {
  const allCategories = {
    'Manager': [
      { 'name': 'iOS', 'icone': 'M17.05 20.28c-.98.95-2.05.8-3.08.35c-1.09-.46-2.09-.48-3.24 0c-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8c1.18-.24 2.31-.93 3.57-.84c1.51.12 2.65.72 3.4 1.8c-3.12 1.87-2.38 5.98.48 7.13c-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25c.29 2.58-2.34 4.5-3.74 4.25' },
      { 'name': 'Android', 'icone': 'm19.817 10.28l.046 2.694h-.023l-.78-2.693h-1.283v3.392h.848l-.046-2.785h.023l.836 2.785h1.227v-3.392zm-16.15 0l-.641 3.428h.928l.47-3.118h.023l.459 3.118h.916l-.63-3.427zm5.181 0l-.424 2.614h-.023l-.424-2.613H6.58l-.069 3.427h.86l.023-3.083h.011l.573 3.083h.871l.573-3.083h.023l.023 3.083h.86l-.08-3.427zm-7.266 2.454a.5.5 0 0 1 .011.252c-.023.114-.103.229-.332.229c-.218 0-.344-.126-.344-.31v-.332H0v.264c0 .768.607.997 1.25.997c.618 0 1.134-.218 1.214-.78c.046-.298.012-.492 0-.561c-.16-.722-1.467-.929-1.559-1.33a.5.5 0 0 1 0-.183c.023-.115.104-.23.31-.23s.32.127.32.31v.206h.86v-.24c0-.745-.676-.86-1.157-.86c-.608 0-1.112.206-1.204.757a1.04 1.04 0 0 0 .012.458c.137.71 1.364.917 1.536 1.352m11.152 0c.034.08.022.184.011.253c-.023.114-.103.229-.332.229c-.218 0-.344-.126-.344-.31v-.332h-.917v.264c0 .756.596.985 1.238.985c.619 0 1.123-.206 1.203-.779c.046-.298.012-.481 0-.562c-.137-.71-1.433-.928-1.524-1.318a.5.5 0 0 1 0-.183c.023-.115.103-.23.31-.23c.194 0 .32.127.32.31v.206h.848v-.24c0-.745-.665-.86-1.146-.86c-.607 0-1.1.195-1.192.757c-.023.149-.023.286.012.458c.137.71 1.34.905 1.513 1.352m2.888.459c.24 0 .31-.16.332-.252c.012-.035.012-.092.012-.126V10.28h.87v2.464c0 .069 0 .195-.01.23c-.058.641-.562.847-1.193.847c-.63 0-1.134-.206-1.192-.848c0-.034-.011-.16-.011-.229V10.28h.87v2.533c0 .046 0 .091.012.126c0 .091.07.252.31.252m7.152-.034c.252 0 .332-.16.355-.253c.011-.034.011-.091.011-.126v-.493h-.355v-.504H24v.917c0 .069 0 .115-.011.23c-.058.63-.597.847-1.204.847s-1.146-.217-1.203-.848c-.012-.114-.012-.16-.012-.229v-1.444c0-.057.012-.172.012-.23c.08-.641.596-.847 1.203-.847s1.135.206 1.203.848c.012.103.012.229.012.229v.115h-.86v-.195s0-.08-.011-.126c-.012-.08-.08-.252-.344-.252c-.252 0-.32.16-.344.252c-.011.045-.011.103-.011.16v1.57c0 .046 0 .092.011.126c0 .092.092.253.333.253' }, 
      { 'name': 'Accessoires', 'icone': 'M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M8 8.5v5M1.5 10H8M.5 4L2 .5h10L13.5 4H.5zm4.25 0v1a2 2 0 0 1-2 2h-.28a2 2 0 0 1-2-2V4m8.78 0v1a2 2 0 0 1-2 2h-.5a2 2 0 0 1-2-2V4m8.75 0v1a2 2 0 0 1-2 2h-.25a2 2 0 0 1-2-2V4' }
    ],
    'Vendeur(se) Accessoires et Téléphone': [
      { 'name': 'iOS', 'icone': 'M17.05 20.28c-.98.95-2.05.8-3.08.35c-1.09-.46-2.09-.48-3.24 0c-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8c1.18-.24 2.31-.93 3.57-.84c1.51.12 2.65.72 3.4 1.8c-3.12 1.87-2.38 5.98.48 7.13c-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25c.29 2.58-2.34 4.5-3.74 4.25' },
      { 'name': 'Android', 'icone': 'm19.817 10.28l.046 2.694h-.023l-.78-2.693h-1.283v3.392h.848l-.046-2.785h.023l.836 2.785h1.227v-3.392zm-16.15 0l-.641 3.428h.928l.47-3.118h.023l.459 3.118h.916l-.63-3.427zm5.181 0l-.424 2.614h-.023l-.424-2.613H6.58l-.069 3.427h.86l.023-3.083h.011l.573 3.083h.871l.573-3.083h.023l.023 3.083h.86l-.08-3.427zm-7.266 2.454a.5.5 0 0 1 .011.252c-.023.114-.103.229-.332.229c-.218 0-.344-.126-.344-.31v-.332H0v.264c0 .768.607.997 1.25.997c.618 0 1.134-.218 1.214-.78c.046-.298.012-.492 0-.561c-.16-.722-1.467-.929-1.559-1.33a.5.5 0 0 1 0-.183c.023-.115.104-.23.31-.23s.32.127.32.31v.206h.86v-.24c0-.745-.676-.86-1.157-.86c-.608 0-1.112.206-1.204.757a1.04 1.04 0 0 0 .012.458c.137.71 1.364.917 1.536 1.352m11.152 0c.034.08.022.184.011.253c-.023.114-.103.229-.332.229c-.218 0-.344-.126-.344-.31v-.332h-.917v.264c0 .756.596.985 1.238.985c.619 0 1.123-.206 1.203-.779c.046-.298.012-.481 0-.562c-.137-.71-1.433-.928-1.524-1.318a.5.5 0 0 1 0-.183c.023-.115.103-.23.31-.23c.194 0 .32.127.32.31v.206h.848v-.24c0-.745-.665-.86-1.146-.86c-.607 0-1.1.195-1.192.757c-.023.149-.023.286.012.458c.137.71 1.34.905 1.513 1.352m2.888.459c.24 0 .31-.16.332-.252c.012-.035.012-.092.012-.126V10.28h.87v2.464c0 .069 0 .195-.01.23c-.058.641-.562.847-1.193.847c-.63 0-1.134-.206-1.192-.848c0-.034-.011-.16-.011-.229V10.28h.87v2.533c0 .046 0 .091.012.126c0 .091.07.252.31.252m7.152-.034c.252 0 .332-.16.355-.253c.011-.034.011-.091.011-.126v-.493h-.355v-.504H24v.917c0 .069 0 .115-.011.23c-.058.63-.597.847-1.204.847s-1.146-.217-1.203-.848c-.012-.114-.012-.16-.012-.229v-1.444c0-.057.012-.172.012-.23c.08-.641.596-.847 1.203-.847s1.135.206 1.203.848c.012.103.012.229.012.229v.115h-.86v-.195s0-.08-.011-.126c-.012-.08-.08-.252-.344-.252c-.252 0-.32.16-.344.252c-.011.045-.011.103-.011.16v1.57c0 .046 0 .092.011.126c0 .092.092.253.333.253' }, 
      { 'name': 'Accessoires', 'icone': 'M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M8 8.5v5M1.5 10H8M.5 4L2 .5h10L13.5 4H.5zm4.25 0v1a2 2 0 0 1-2 2h-.28a2 2 0 0 1-2-2V4m8.78 0v1a2 2 0 0 1-2 2h-.5a2 2 0 0 1-2-2V4m8.75 0v1a2 2 0 0 1-2 2h-.25a2 2 0 0 1-2-2V4' }
    ],
    'Vendeur(se) Téléphone': [
      { 'name': 'iOS', 'icone': 'M17.05 20.28c-.98.95-2.05.8-3.08.35c-1.09-.46-2.09-.48-3.24 0c-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8c1.18-.24 2.31-.93 3.57-.84c1.51.12 2.65.72 3.4 1.8c-3.12 1.87-2.38 5.98.48 7.13c-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25c.29 2.58-2.34 4.5-3.74 4.25' },
      { 'name': 'Android', 'icone': 'm19.817 10.28l.046 2.694h-.023l-.78-2.693h-1.283v3.392h.848l-.046-2.785h.023l.836 2.785h1.227v-3.392zm-16.15 0l-.641 3.428h.928l.47-3.118h.023l.459 3.118h.916l-.63-3.427zm5.181 0l-.424 2.614h-.023l-.424-2.613H6.58l-.069 3.427h.86l.023-3.083h.011l.573 3.083h.871l.573-3.083h.023l.023 3.083h.86l-.08-3.427zm-7.266 2.454a.5.5 0 0 1 .011.252c-.023.114-.103.229-.332.229c-.218 0-.344-.126-.344-.31v-.332H0v.264c0 .768.607.997 1.25.997c.618 0 1.134-.218 1.214-.78c.046-.298.012-.492 0-.561c-.16-.722-1.467-.929-1.559-1.33a.5.5 0 0 1 0-.183c.023-.115.104-.23.31-.23s.32.127.32.31v.206h.86v-.24c0-.745-.676-.86-1.157-.86c-.608 0-1.112.206-1.204.757a1.04 1.04 0 0 0 .012.458c.137.71 1.364.917 1.536 1.352m11.152 0c.034.08.022.184.011.253c-.023.114-.103.229-.332.229c-.218 0-.344-.126-.344-.31v-.332h-.917v.264c0 .756.596.985 1.238.985c.619 0 1.123-.206 1.203-.779c.046-.298.012-.481 0-.562c-.137-.71-1.433-.928-1.524-1.318a.5.5 0 0 1 0-.183c.023-.115.103-.23.31-.23c.194 0 .32.127.32.31v.206h.848v-.24c0-.745-.665-.86-1.146-.86c-.607 0-1.1.195-1.192.757c-.023.149-.023.286.012.458c.137.71 1.34.905 1.513 1.352m2.888.459c.24 0 .31-.16.332-.252c.012-.035.012-.092.012-.126V10.28h.87v2.464c0 .069 0 .195-.01.23c-.058.641-.562.847-1.193.847c-.63 0-1.134-.206-1.192-.848c0-.034-.011-.16-.011-.229V10.28h.87v2.533c0 .046 0 .091.012.126c0 .091.07.252.31.252m7.152-.034c.252 0 .332-.16.355-.253c.011-.034.011-.091.011-.126v-.493h-.355v-.504H24v.917c0 .069 0 .115-.011.23c-.058.63-.597.847-1.204.847s-1.146-.217-1.203-.848c-.012-.114-.012-.16-.012-.229v-1.444c0-.057.012-.172.012-.23c.08-.641.596-.847 1.203-.847s1.135.206 1.203.848c.012.103.012.229.012.229v.115h-.86v-.195s0-.08-.011-.126c-.012-.08-.08-.252-.344-.252c-.252 0-.32.16-.344.252c-.011.045-.011.103-.011.16v1.57c0 .046 0 .092.011.126c0 .092.092.253.333.253' }
    ],
    'Vendeur(se) Accessoires': [
      { 'name': 'Accessoires', 'icone': 'M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M8 8.5v5M1.5 10H8M.5 4L2 .5h10L13.5 4H.5zm4.25 0v1a2 2 0 0 1-2 2h-.28a2 2 0 0 1-2-2V4m8.78 0v1a2 2 0 0 1-2 2h-.5a2 2 0 0 1-2-2V4m8.75 0v1a2 2 0 0 1-2 2h-.25a2 2 0 0 1-2-2V4' }
    ]
  };
  categoriesT.value = allCategories[poste] || [];
};

// Initialize
onMounted(() => {
  setCategories(user.value.poste);
  fetchProduitsFiltres();
});
</script>

<style scoped>
/* Spinner animation amélioré */
.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  position: relative;
}

.spinner div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spinner-rotate 0.8s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.spinner div:nth-child(1) {
  animation-delay: -0.3s;
  border-width: 2px;
}

.spinner div:nth-child(2) {
  animation-delay: -0.15s;
  border-width: 1px;
}

@keyframes spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Style pour bouton désactivé */
button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>